<ng-container *transloco="let t">
  <div
    class="container mx-auto px-4 navigation-container"
    (scroll)="onNavigationScroll()"
  >
    <div
      class="flex items-center justify-between w-full mb-2 flex-wrap header-row"
    >
      <div class="flex items-center gap-2 flex-1 min-w-0 pt-2 notes-wrap">
        @if (
          userRole === 'ClinicOwner' ||
          userRole === 'Clinic' ||
          userRole === 'Veterinarian'
        ) {
          @for (note of storeNotes.pinNotes(); track note.uid) {
            @if (userRole === 'ClinicOwner') {
              @if (!note.shared) {
                <div
                  class="notes"
                  (click)="openNoteDetail(note)"
                  role="button"
                  tabindex="0"
                  aria-label="Close tab"
                  (keydown.enter)="openNoteDetail(note)"
                  (keydown.space)="openNoteDetail(note)"
                >
                  <mat-icon class="pin-blue-icon icon-s"></mat-icon>
                  <div class="column">
                    <p
                      [matTooltip]="note.title"
                      matTooltipShowDelay="200"
                      matTooltipPosition="above"
                    >
                      {{ note.title! | limitTo: 20 }}
                    </p>
                    <span
                      [matTooltip]="note.description"
                      matTooltipShowDelay="200"
                      matTooltipPosition="above"
                    >
                      {{ note.description! | limitTo: 50 }}
                    </span>
                  </div>
                </div>
              }
            } @else {
              <div
                class="notes"
                (click)="openNoteDetail(note)"
                role="button"
                tabindex="0"
                aria-label="Close tab"
                (keydown.enter)="openNoteDetail(note)"
                (keydown.space)="openNoteDetail(note)"
              >
                <mat-icon class="pin-blue-icon icon-s"></mat-icon>
                <div class="column">
                  <p
                    [matTooltip]="note.title"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                  >
                    {{ note.title! | limitTo: 20 }}
                  </p>
                  <span
                    [matTooltip]="note.description"
                    matTooltipShowDelay="200"
                    matTooltipPosition="above"
                  >
                    {{ note.description! | limitTo: 50 }}
                  </span>
                </div>
              </div>
            }
          }
        }
      </div>

      <div
        class="flex gap-9 justify-end flex-nowrap overflow-x-auto min-w-0 flex-shrink-0 header-right-controls"
        style="height: 42px"
      >
        @if (showEnvironmentBanner) {
          <div
            class="environment-badge mt-2 flex-shrink-0"
            [attr.title]="t('portal.environment.testingBanner')"
          >
            {{ t('portal.environment.testingBadge') }}
          </div>
        }

        <div class="mt-2 flex items-center text-sm text-gray-500 flex-shrink-0">
          <span class="icon calendar-icon mr-2"></span>
          <p class="whitespace-nowrap overflow-hidden text-ellipsis">
            {{ currentTime() | localDate: 'fullDate' : lang() }}
          </p>
        </div>

        <div
          class="mt-2 flex justify-end items-center text-sm text-gray-500 flex-shrink-0"
        >
          <span class="icon clock-icon mr-2"></span>
          <span
            class="calendar whitespace-nowrap overflow-hidden text-ellipsis"
          >
            {{ currentTime() | localDate: 'HH:mm' : lang() }}
          </span>
        </div>

        <!-- Notification bell — visible for Clinic/ClinicOwner/Manager roles -->
        @if (
          userRole === 'ClinicOwner' ||
          userRole === 'Clinic' ||
          userRole === 'Manager' ||
          userRole === 'Administrator'
        ) {
          <div class="notif-wrap flex-shrink-0">
            <button
              #notifBellBtn
              class="icon-button"
              aria-label="Notifications"
              (click)="toggleNotifications()"
            >
              <span class="notif-bell-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  style="color: #667085; margin-top: 0.5rem"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                @if (shellStore.unreadCount() > 0) {
                  <span class="notif-badge">{{
                    shellStore.unreadCount()
                  }}</span>
                }
              </span>
            </button>

            @if (notificationsOpen()) {
              <div
                class="notif-backdrop"
                (click)="notificationsOpen.set(false)"
              ></div>
              <div
                @opacityInOut
                class="notifications-panel"
                [ngStyle]="notifPanelStyle()"
              >
                <div class="notifications-header">
                  <span>{{ t('Notifications') }}</span>
                  @if (
                    shellStore.cancellationNotifications().some(n => !n.pinned)
                  ) {
                    <button
                      class="notif-clear-btn"
                      (click)="shellStore.clearAll()"
                    >
                      {{ t('Clear all') }}
                    </button>
                  }
                </div>
                <div class="notifications-list">
                  @if (shellStore.cancellationNotifications().length === 0) {
                    <div class="notifications-empty">
                      {{ t('No notifications') }}
                    </div>
                  }
                  @for (n of shellStore.sortedNotifications(); track n.uid) {
                    <div
                      class="notification-item"
                      [class.notification-clickable]="
                        isClickableNotification(n.type)
                      "
                      [class.notification-warning]="
                        n.type === 'subscription-warning' ||
                        n.type === 'low-stock' ||
                        n.type === 'invoice-payment-due' ||
                        n.type === 'manager-contract-at-risk' ||
                        n.type === 'manager-premium-package'
                      "
                      [class.notification-success]="
                        n.type === 'subscription-renewed'
                      "
                      (click)="onNotificationClick(n)"
                      role="button"
                      [tabindex]="isClickableNotification(n.type) ? 0 : -1"
                      (keydown.enter)="onNotificationClick(n)"
                      (keydown.space)="onNotificationClick(n)"
                    >
                      <div class="notif-item-row">
                        @if (n.isNew) {
                          <span class="notif-new-dot" title="New"></span>
                        }
                        @if (
                          n.type === 'subscription-warning' ||
                          n.type === 'low-stock' ||
                          n.type === 'invoice-payment-due'
                        ) {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#f59e0b"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="notif-cancel-icon"
                          >
                            <path
                              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                            />
                            <line x1="12" y1="9" x2="12" y2="13" />
                            <line x1="12" y1="17" x2="12.01" y2="17" />
                          </svg>
                        } @else if (n.type === 'appointment-request') {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#3b82f6"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="notif-cancel-icon"
                          >
                            <rect x="3" y="4" width="18" height="18" rx="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                          </svg>
                        } @else if (n.type === 'subscription-renewed') {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#22c55e"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="notif-cancel-icon"
                          >
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                            <polyline points="22 4 12 14.01 9 11.01" />
                          </svg>
                        } @else {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ef4444"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="notif-cancel-icon"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="15" y1="9" x2="9" y2="15" />
                            <line x1="9" y1="9" x2="15" y2="15" />
                          </svg>
                        }
                        <span class="notif-item-text">{{ notificationText(n) }}</span>
                        @if (!n.pinned) {
                          <button
                            type="button"
                            class="notif-dismiss-btn"
                            [attr.aria-label]="t('Dismiss')"
                            (click)="dismissNotification($event, n.uid)"
                          >
                            ✕
                          </button>
                        }
                      </div>
                      <div class="notif-time">
                        {{ n.createdAt | date: 'HH:mm' }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="tabs-bar">
      @if (showCloseAllTabsButton()) {
        <button
          type="button"
          class="close-all-tabs-tab"
          [matTooltip]="t('Close all tabs')"
          matTooltipShowDelay="200"
          matTooltipPosition="below"
          [attr.aria-label]="t('Close all tabs')"
          (click)="closeAllTabs($event)"
        >
          <span class="icon close-icon icon-xs"></span>
        </button>
      }

      <nav
        id="tabNav"
        #tabNav
        class="tabs-scrollable flex space-x-4 overflow-x-auto whitespace-nowrap"
        aria-label="Tabs"
      >
      @for (tab of tabs(); track tab; let i = $index) {
        @if (i === selectedIndex()) {
          <div
            id="tab-{{ i }}"
            class="bg-gray-200 active-tab-background active-tab-text rounded-md px-3 py-2 text-sm font-medium flex gap-2 items-center"
            aria-current="page"
            (click)="onTabClick(i)"
            role="button"
            tabindex="0"
            aria-label="Close tab"
            (keydown.enter)="onTabClick(i)"
            (keydown.space)="onTabClick(i)"
          >
            <div class="tab-content">
              <span
                [ngClass]="[tabIcon(tab), 'icon', 'icon-xs', 'tab-icon']"
              ></span>
              <span class="truncate">{{ t(tabLabel(tab)) }}</span>
            </div>
            <span
              class="icon-xs icon close-icon margin-left-xs cursor-pointer"
              (click)="deleteTab($event, tab, i)"
              role="button"
              tabindex="0"
              aria-label="Close tab"
              (keydown.enter)="deleteTab($any($event), tab, i)"
              (keydown.space)="deleteTab($any($event), tab, i)"
            ></span>
          </div>
        } @else {
          <div
            id="tab-{{ i }}"
            class="text-gray-500 deselect-background deselect-text hover:text-gray-700 rounded-md px-3 py-2 text-sm font-medium flex items-center"
            (click)="onTabClick(i)"
            role="button"
            tabindex="0"
            aria-label="Close tab"
            (keydown.enter)="onTabClick(i)"
            (keydown.space)="onTabClick(i)"
          >
            <div class="tab-content">
              <span
                [ngClass]="[tabIcon(tab), 'icon', 'icon-xs', 'tab-icon']"
              ></span>
              <span class="truncate">{{ t(tabLabel(tab)) }}</span>
            </div>
            <span
              class="icon-xs icon close-icon margin-left-xs cursor-pointer"
              (click)="deleteTab($event, tab, i)"
              role="button"
              tabindex="0"
              aria-label="Close tab"
              (keydown.enter)="deleteTab($any($event), tab, i)"
              (keydown.space)="deleteTab($any($event), tab, i)"
            ></span>
          </div>
        }
      }
      </nav>
    </div>

    @if (showClinicWelcomeScreen()) {
      <anihis-clinic-welcome-screen />
    } @else {
      <anihis-all-pages-import
        [tab]="tabs()[selectedIndex()]"
      ></anihis-all-pages-import>
    }
  </div>
</ng-container>
